<template>
    <div></div>
</template>

<script>
    export default {
        name: "PressVisa"
    }
</script>

<style scoped>

</style>